import React, { useState, useEffect } from 'react';
import { PLACEHOLDER_IMAGE } from '../assets/landingImages';

/**
 * Image with automatic fallback to a free placeholder if the primary URL fails.
 * Syncs when `src` changes so lecture switches do not show a stale picture.
 */
export default function SafeImage({
  src,
  alt = '',
  fallback = PLACEHOLDER_IMAGE,
  className,
  style,
  loading = 'lazy',
  ...rest
}) {
  const [currentSrc, setCurrentSrc] = useState(src || fallback);

  useEffect(() => {
    setCurrentSrc(src || fallback);
  }, [src, fallback]);

  return (
    <img
      {...rest}
      src={currentSrc || fallback}
      alt={alt}
      className={className}
      style={style}
      loading={loading}
      onError={() => {
        if (currentSrc !== fallback) setCurrentSrc(fallback);
      }}
    />
  );
}
